import { H1, useBreadcrumbs } from "@inmagik/magik-ui"
import { Formik } from "formik"
import { useMemo } from "react"
import { Container } from "react-bootstrap"
import { useNavigate } from "react-router-dom"
import BottomFormFixed from "../../components/BottomFormFixed"
import Layout from "../../components/Layout"
import { ScrollLayout } from "../../components/ScrollLayout"
import { useCreateGroupOfResearch } from "../../hooks/group-of-researches"
import { type GroupOfResearches } from "../../types"
import { initialValuesGroupOfResearch, validationSchemaGroupOfResearch } from "./GroupOfResearchCommon"
import GenreForm from "./GroupOfResearchForm"

export default function GroupOfResearchCreate() {
  const createGroupOfResearch = useCreateGroupOfResearch()
  const navigate = useNavigate()

  const initialValues = useMemo(() => initialValuesGroupOfResearch(), [])
  const validationSchema = useMemo(() => validationSchemaGroupOfResearch(), [])

  useBreadcrumbs([
    { label: "Gruppi di Ricerca", href: "/group-of-researches/groups-of-researches" },
    { label: "Creazione Gruppo di Ricerca" },
  ])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <H1>Nuovo gruppo di ricerca</H1>
        <ScrollLayout.Scroll>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              return createGroupOfResearch.mutateAsync(values as GroupOfResearches).then((group) => {
                navigate(`/group-of-researches/group-of-researches/${group.id}`)
              })
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Container fluid className="mt-6" style={{ marginBottom: "100px" }}>
                  <GenreForm />
                </Container>
                <BottomFormFixed url="/group-of-researches/group-of-researches" />
              </form>
            )}
          </Formik>
        </ScrollLayout.Scroll>
      </ScrollLayout>
    </Layout>
  )
}
